var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"backgroundHeaderTitle"},[_c('div',{staticClass:"headertitle"},[_c('div',{staticClass:"imageWrapper"},[_c('v-img',{attrs:{"height":"400px","src":_vm.imageUrl}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }